const POPULAR_PRODUCTS = {
  popular: {
    default: {
      groupDisplayName: 'PopularRightNow_Title',
      colorTheme: 'gray',
      productListingType: 'multi-slider',
    },
    all: { displayName: 'All' },
    laptops: { displayName: 'PortableComputers' },
    smartphones: { displayName: 'Smartphones' },
    network: { displayName: 'Network' },
    mice: { displayName: 'Mice' },
    displays: { displayName: 'Displays' },
    keyboards: { displayName: 'Keyboards' },
  },
}

const DISCOUNTED = {
  discounted: {
    default: {
      colorTheme: 'gray',
      displayName: 'Startpage_BestsellersOnSale',
      ctaText: 'ShowAll',
      productListingType: 'slider',
      ['ctaLink_da-dk']: '/kampagne',
      ['ctaLink_fi-fi']: '/kampanja',
      ['ctaLink_nb-no']: '/kampanje',
      ['ctaLink_nl-nl']: '/campagnes',
      ['ctaLink_sv-se']: '/kampanj',
    },
  },
}

const NEW_PRODUCTS = {
  new: {
    default: {
      displayName: 'Startpage_NewProducts',
      ctaText: 'ShowAll',
      productListingType: 'slider',
      colorTheme: 'gray',
      ['ctaLink_da-dk']: '/nye-produkter',
      ['ctaLink_fi-fi']: '/uudet-tuotteet',
      ['ctaLink_nb-no']: '/nye-produkter',
      ['ctaLink_nl-nl']: '/nieuwe-producten',
      ['ctaLink_sv-se']: '/nya-produkter',
    },
  },
}

const VOXICON_PRODUCTS = {
  voxicon: {
    default: {
      displayName: 'Startpage_DustinsOwnProducts',
      ctaText: 'ReadMore',
      colorTheme: 'gray',
      productListingType: 'slider',
      ['ctaLink_da-dk']: '/om-dustin/vores-egne-varemaerker',
      ['ctaLink_fi-fi']: '/tietoa-meista/omat-tuotemerkkimme',
      ['ctaLink_nb-no']: '/om-dustin/vaare-egne-varemerker',
      ['ctaLink_nl-nl']: '/over-dustin/onze-eigen-merken',
      ['ctaLink_sv-se']: '/om-dustin/vara-egna-varumarken',
    },
    displays: { displayName: 'Displays' },
    mice: { displayName: 'Mice' },
    keyboards: { displayName: 'Keyboards' },
    headsets: { displayName: 'Headsets' },
    webcameras: { displayName: 'Webcameras' },
  },
}

const CIRAFON_PRODUCTS = {
  cirafon: {
    default: {
      displayName: 'Popular_Cirafon_Products',
      productListingType: 'slider',
      colorTheme: 'gray',
    },
    chargers: { displayName: 'Chargers & Cables' },
    privacy: { displayName: 'Privacy_Filters' },
    cases: { displayName: 'Cases_&_Covers' },
    protectors: { displayName: 'Screen_Protectors' },
    bags: { displayName: 'Bags_And_Backpacks' },
  },
}

const CAMPAIGN_PRODUCTS = {
  campaign: {
    default: {
      colorTheme: 'purple',
      displayName: 'Startpage_BestsellersOnSale',
      ctaText: 'ShowAll',
      productListingType: 'slider',
      ['ctaLink_da-dk']: '/kampagne',
      ['ctaLink_fi-fi']: '/kampanja',
      ['ctaLink_nb-no']: '/kampanje',
      ['ctaLink_nl-nl']: '/campagnes',
      ['ctaLink_sv-se']: '/kampanj',
    },
  },
}

const HISTORY_PRODUCTS = {
  history: {
    default: {
      colorTheme: 'gray',
      displayName: 'Startpage_RecentlyViewed',
      productListingType: 'aside',
      stickyOnLarge: 'true',
    },
    headphones: {
      displayName: 'Startpage_PopularHeadsets',
      productListingType: 'slider',
    },
  },
}

const RECOMMENDED_PRODUCTS = {
  recommended: {
    default: {
      displayName: 'RecommendedForYou',
      productListingType: 'slider',
    },
  },
}

const STARTPAGE_B2B = {
  b2b: {
    default: {
      ...NEW_PRODUCTS,
      ...DISCOUNTED,
      ...POPULAR_PRODUCTS,
      ...VOXICON_PRODUCTS,
      ...CIRAFON_PRODUCTS,
    },
    personal: {
      ...RECOMMENDED_PRODUCTS,
      ...NEW_PRODUCTS,
      ...DISCOUNTED,
      ...HISTORY_PRODUCTS,
      ...POPULAR_PRODUCTS,
      ...VOXICON_PRODUCTS,
      ...CIRAFON_PRODUCTS,
    },
  },
}

const STARTPAGE_B2C = {
  b2c: {
    default: {
      ...NEW_PRODUCTS,
      ...CAMPAIGN_PRODUCTS,
      ...VOXICON_PRODUCTS,
      ...CIRAFON_PRODUCTS,
    },
    personal: {
      ...RECOMMENDED_PRODUCTS,
      ...HISTORY_PRODUCTS,
      ...CAMPAIGN_PRODUCTS,
      ...NEW_PRODUCTS,
      ...VOXICON_PRODUCTS,
      ...CIRAFON_PRODUCTS,
    },
  },
}

const STARTPAGE = {
  ...STARTPAGE_B2B,
  ...STARTPAGE_B2C,
}

const NO_RESULTS_PAGE = {
  ...POPULAR_PRODUCTS,
}

export const getAttributesMap = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ATTRIBUTES = new Map<string, any>()

  ATTRIBUTES.set('startpage', STARTPAGE)
  ATTRIBUTES.set('no-search-results', NO_RESULTS_PAGE)

  return ATTRIBUTES
}
